import { useAtom } from 'jotai'
import { useTranslation } from 'react-i18next'

import { chatIdAtom } from '@/store/gigiChat/ChatAtom'
import { currentFeedbackAtom, feedbackAtom, showFeedbackDrawerAtom, updateFeedbackCallback } from '@/store/gigiChat/Feedback'
import { addNotification } from '@/store/gigiChat/Notifications'
import { IFeedback, TFeedback, TReason } from '@/types/gigiChat/Feedback'

import Feedback from './Feedback'

const Container = ({ userPromptId, externalFeedback }: { userPromptId: number | null; externalFeedback: IFeedback | null }) => {
    const { t } = useTranslation()
    const [chatID] = useAtom(chatIdAtom)
    const [, updateFeedback] = useAtom(feedbackAtom)
    const [, toggleDrawer] = useAtom(showFeedbackDrawerAtom)
    const [, updateCurrentFeedback] = useAtom(currentFeedbackAtom)

    let feedback: IFeedback = {
        userPromptId: userPromptId,
        type: externalFeedback?.type || null,
        comment: externalFeedback?.comment || null,
    }

    const provideReason = (reason: TReason) => {
        if (reason === 'other' || reason === 'positive') {
            toggleDrawer(true)
        } else {
            feedback.comment = reason

            void updateFeedback([{ chatID, body: feedback }]).then(() => {
                updateFeedbackCallback(feedback)
                addNotification('success', t('chat.feedback.toast.success'))
            })
        }
    }
    const updateFeedbackType = (type: TFeedback) => {
        // if first time or feedback is the oposite from what is already selected
        if (!feedback.type || type !== feedback.type) {
            feedback = {
                ...feedback,
                type: type,
                comment: null,
            }

            void updateFeedback([{ chatID, body: feedback }]).then(() => {
                updateFeedbackCallback(feedback)
            })
        }
        // if the user takes his feedback back
        else if (feedback.type === type) {
            feedback = {
                ...feedback,
                type: 'neutral',
                comment: null,
            }
            void updateFeedback([{ chatID, body: feedback }]).then(() => {
                updateFeedbackCallback(feedback)
            })
        }
    }

    const setCurrentFeedback = () => {
        updateCurrentFeedback(feedback)
    }
    return (
        userPromptId && (
            <Feedback
                updateFeedbackType={updateFeedbackType}
                provideReason={provideReason}
                feedback={feedback}
                setCurrentFeedback={setCurrentFeedback}
            />
        )
    )
}

export default Container
